import React, { useState, useEffect, useRef, useContext } from "react";
import {
  ContentWrapper,
  SnackbarContent,
  PageTitle,
  PageSecondTitle,
} from "../styled-components/shared";
import { useLocation } from "react-router-dom";

import {
  Button,
  RadioButtonGroup,
  Item,
  Switch,
} from "@zebra-fed/zds-react-desktop";
import Snackbar from "@material-ui/core/Snackbar";
import styled from "styled-components";
import firebaseUtil from "../data/FirebaseUtil";
import { DataContext } from "../data/DataContext";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  Typography,
  Link,
} from "@material-ui/core";

import { AuthContext } from "../authentication/Auth";
import app from "../authentication/firebaseStart";
import BottomNavLinks from "../components/BottomNavLinks";
import Grid from "@material-ui/core/Grid";
import CloudUploadIcon from "@material-ui/icons/GetApp";
import Tooltip from "@material-ui/core/Tooltip";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { withStyles } from "@material-ui/core/styles";
import { getURLFromGCSBucket } from "./commonUtils/ExportUtils";
import { SVGContainer, TTBody } from "../styled-components/shared";

const firestore = app.firestore();

const StyledContentWrapper = styled(ContentWrapper)`
  padding: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  max-width: 500px;
  ${
    "" /* align-items: center;
  justify-content: center; */
  }
`;

const RuleTitle = styled.div`
  display: flex;
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
`;

const RuleSubTitle = styled.div`
  display: flex;
  font-size: 20px;
  margin-top: 20px;
  color: #007aba;
  margin-bottom: 16px;
`;

export default function DeviceRegistrationPage() {
  const context = useContext(AuthContext);
  let { globalAppSettings, setGlobalAppSettings } = useContext(DataContext);
  const [appSettings, setAppSettings] = useState(globalAppSettings);
  //console.log(appSettings,'appSettings atfirst');
  //console.log(appSettings?.userRoleSettings.manager.Device,'appSettings.userRoleSettings.manager.Device');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(true);
  const [deviceNameMod, setDeviceNameMod] = useState(false);
  const [apsMod, setApsMod] = useState(false);
  const [prevLink, setPrevLink] = useState("");
  const [nextLink, setNextLink] = useState("");
  const [saveButtonStatus, setSaveButtonStatus] = useState(true);
  const { t } = useTranslation();
  const deviceRegTypeRef = useRef(0);
  const serverResponse = useRef("");

  let location = useLocation();
  let pathtest = location.pathname;

  useEffect(() => {
    if (Object.keys(globalAppSettings).length > 0) {
      setAppSettings({
        ...globalAppSettings,
        prefix: globalAppSettings.prefix ? globalAppSettings.prefix.trim() : "",
      });
      setIsLoading2(false);
    } else {
      setTimeout(() => {
        setIsLoading2(false);
      }, 1000);
    }
  }, [globalAppSettings]);

  useEffect(() => {
    setDeviceNameMod(
      appSettings?.userRoleSettings?.manager?.Devices?.length && appSettings?.userRoleSettings?.manager?.Devices[0] === "update" ? true : false
    );
    setApsMod(
      appSettings?.userRoleSettings?.manager?.Aps?.length && appSettings?.userRoleSettings?.manager?.Aps[0] === "write" ? true : false
    );
  }, [appSettings?.userRoleSettings]);

  const [exportBtnState, setexportBtnState] = useState("none");

  const getGCSBarcodeURL = async (companyID) => {
    return await firestore
      .collection("tenants")
      .doc(companyID)
      .collection("Configuration")
      .doc("DeviceEnrollment").get().then(doc=>{
        if (doc.data() && doc.data().enrollmentGCSUrl){
          return doc.data().enrollmentGCSUrl;
        }      
        //if config file is not generated during deployment, call CF to generate barcode file
        return firebaseUtil
          .generateXmlAndBarcodeZip()
          .then((response) => {
            console.log("response", response);
            if(response.status === "Success") return response.enrollmentGCSUrl
            return ""
          })
          .catch((err) => {
            console.log("Error in getting the site events", err);
            serverResponse.current = err.response.data;
            setSnackbarOpen(true);
            setexportBtnState("none");
            throw new Error("File not present")
          });
        })
  };

  const downloadZip = async () => {
    let companyID = context.currentUser.claims.companyID;
    console.log("tenant:" + companyID);
    setexportBtnState("down");
    let gcsUrl = await getGCSBarcodeURL(companyID);
    try {
      let filename = "DeviceEnrollment";
      console.log("Getting file");
      async function getURL() {
        console.log(" gcsUrl", gcsUrl);
        let result = await getURLFromGCSBucket(gcsUrl, companyID, filename);
        setexportBtnState("none");
      }
      getURL();
    } catch (error) {
      setexportBtnState("none");
    }
  };
  async function exportEnrollmentZip() {
    downloadZip();
  }
  async function handleChange(e) {
    setAppSettings({
      ...appSettings,
      deviceRegistrationType: deviceRegTypeRef.current.getValues()[0],
    });
    setSaveButtonStatus(false);
  }

  async function handleSave() {
    setGlobalAppSettings(appSettings);
    let data = {
      checkoutBarcodePrefix: appSettings.prefix
        ? appSettings.prefix.trim()
        : "",
      globalSupervisorEnabled: appSettings.globalSupervisor,
      maxCheckoutTime: appSettings.maxCheckoutTime
        ? appSettings.maxCheckoutTime
        : "",
      deviceCheckinOption: appSettings.deviceCheckinOption,
      deviceRegistrationType: appSettings.deviceRegistrationType
        ? appSettings.deviceRegistrationType
        : 0,
      userRoleSettings: appSettings.userRoleSettings,
    };
    setIsLoading(true);
    let response = await firebaseUtil.saveAppSettings(data);
    setIsLoading(false);
    serverResponse.current = response;
    if (response.status) {
      setSaveButtonStatus(true);
    }
    setSnackbarOpen(true);
  }

  const onDeviceNameSwitch = (deviceNameSwitch) => {
    if (deviceNameSwitch !== deviceNameMod) setSaveButtonStatus(false);

    let arrAps = appSettings?.userRoleSettings?.manager?.Aps;
    if (deviceNameSwitch) {
      let arr = ["update"];

      setAppSettings((appSettings) => ({
        ...appSettings,
        userRoleSettings: {
          ...appSettings?.userRoleSettings,
          manager: { Devices: arr, Aps: arrAps },
        },
      }));
    } else {
      let arr = [""];
      setAppSettings((appSettings) => ({
        ...appSettings,
        userRoleSettings: {
          ...appSettings?.userRoleSettings,
          manager: { Devices: arr, Aps: arrAps },
        },
      }));
    }
  };
  const onChangeSwitch = (changeAps) => {
    if (changeAps !== apsMod) setSaveButtonStatus(false);

    //setSaveButtonStatus(false);
    let arrDevice = appSettings?.userRoleSettings?.manager?.Devices;
    if (changeAps) {
      let arr = ["write"];
      setAppSettings((appSettings) => ({
        ...appSettings,
        userRoleSettings: {
          ...appSettings?.userRoleSettings,
          manager: { Aps: arr, Devices: arrDevice },
        },
      }));
    } else {
      let arr = [""];
      setAppSettings((appSettings) => ({
        ...appSettings,
        userRoleSettings: {
          ...appSettings?.userRoleSettings,
          manager: { Aps: arr, Devices: arrDevice },
        },
      }));
    }
  };

  const onClickResetBtn = () => {
    //setApsData(false);
    //setDeviceData(false);
    let makeEmpty = [""];
    //setAppSettings({appSettings.userRoleSettings.manager.Devices: false})
    setAppSettings((appSettings) => ({
      ...appSettings,
      deviceRegistrationType: 0,
      userRoleSettings: {
        ...appSettings?.userRoleSettings,
        manager: { Devices: makeEmpty, Aps: makeEmpty },
      },
    }));
  };
  const onClickCancelBtn = () => {
    setSaveButtonStatus(true);
  };

  const ButtonStyle = {
    display: "flex",
    alignSelf: "flex-end",
    cursor: isLoading ? "wait" : "pointer",
  };
  const QuestionTT = withStyles((theme) => ({
    tooltip: {
      backgroundColor: "rgb(0, 122, 186)",
      color: theme.typography.pxToRem(12),
      maxWidth: 300,
      border: "1px solid rgb(0, 122, 186)",
    },

    arrow: {
      color: "rgb(0, 122, 186)",
    },
  }))(Tooltip);
  return (
    <>
      <StyledContentWrapper
        style={{
          cursor: isLoading ? "wait" : "default",
          opacity: isLoading ? "0.4" : "1",
        }}
      >
        <PageTitle style={{ marginBottom: "0px", justifyContent: "normal" }}>
          {t("deviceRegistration.registration")}
          <QuestionTT
            arrow
            title={
              <>
                <TTBody>
                  <p>{t("deviceRegistration.deviceEnrollmentToolTip")}</p>
                </TTBody>
              </>
            }
          >
            <SVGContainer>
              <HelpOutlineIcon />
            </SVGContainer>
          </QuestionTT>
        </PageTitle>
        <div
          style={{
            display: isLoading2 ? "flex" : "none",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </div>
        <Grid container spacing={1}>
          <Grid item xs={5} style={{ alignSelf: "center" }}>
            <Item>{t("deviceRegistration.deviceEnrollment")}</Item>
          </Grid>
          <Grid item xs={6}>
            <Item>
              <Button
                outlined="true"
                type="outlined"
                style={{
                  color:
                    exportBtnState == "none"
                      ? "#007ABA"
                      : exportBtnState == "exporting"
                      ? "#ffc107"
                      : exportBtnState == "down"
                      ? "#8bc34a"
                      : "#007ABA",
                  cursor: exportBtnState == "none" ? "pointer" : "not-allowed",
                }}
                onClick={exportEnrollmentZip}
              >
                <b>
                  {`${
                    exportBtnState === "none"
                      ? t("deviceRegistration.downloadEnrollmentFiles")
                      : exportBtnState === "exporting"
                      ? t("exporting")
                      : exportBtnState === "down"
                      ? t("downloading")
                      : null
                  }`}
                </b>

                <CloudUploadIcon
                  style={{
                    marginLeft: "10px",
                    position: "relative",
                    top: "7px",
                  }}
                />
              </Button>
            </Item>
          </Grid>
        </Grid>
        <div style={{ display: isLoading2 ? "none" : "block" }}>
          <RuleSubTitle>
            {t("deviceRegistration.deviceRegistrationHeading")}
            <QuestionTT
              arrow
              title={
                <>
                  <TTBody>
                    <p>{t("deviceRegistration.siteAssignmentToolTip")}</p>
                  </TTBody>
                </>
              }
            >
              <SVGContainer>
                <HelpOutlineIcon />
              </SVGContainer>
            </QuestionTT>
          </RuleSubTitle>

          <div style={{ display: isLoading2 ? "none" : "block" }}>
            <RadioButtonGroup
              key="deviceRegistrationType"
              ref={deviceRegTypeRef}
              name="deviceRegistrationType"
              align="left"
              onChange={handleChange}
            >
              <Item
                key="0"
                value={0}
                defaultChecked={
                  appSettings.deviceRegistrationType === 0 ||
                  appSettings.deviceRegistrationType === -1 ||
                  appSettings.deviceRegistrationType === undefined
                }
              >
                {t("deviceRegistration.manual")}
              </Item>
              <Item
                key="1"
                value={1}
                defaultChecked={appSettings.deviceRegistrationType === 1}
              >
                {t("deviceRegistration.connectedAP")}
              </Item>
              <Item
                key="2"
                value={2}
                defaultChecked={appSettings.deviceRegistrationType === 2}
              >
                {t("deviceRegistration.ipRangeConfig")}
              </Item>
            </RadioButtonGroup>

            <RuleSubTitle style={{ marginBottom: "10px", marginTop: "20px" }}>
              {t("deviceRegistration.managerPermissions")}
            </RuleSubTitle>
            <FormControl component="fieldset" style={{ paddingLeft: 10 }}>
              <FormControlLabel
                className="onOffSwitch"
                labelPlacement="end"
                style={{ paddingTop: 15 }}
                control={
                  <Switch
                    color="primary"
                    checked={
                      appSettings?.userRoleSettings?.manager?.Devices?.length && appSettings?.userRoleSettings?.manager?.Devices[0] ===
                      "update"
                        ? true
                        : false
                    }
                    onChange={(e) => onDeviceNameSwitch(e)}
                  />
                }
                label={t("deviceRegistration.AllowmanagerstomodifyDevicename")}
              />
              <FormControlLabel
                className="onOffSwitch"
                labelPlacement="end"
                style={{ paddingTop: 15, paddingBottom: 15 }}
                control={
                  <Switch
                    color="primary"
                    checked={
                      appSettings?.userRoleSettings?.manager?.Aps?.length && appSettings?.userRoleSettings?.manager?.Aps[0] === "write"
                        ? true
                        : false
                    }
                    onChange={(e) => onChangeSwitch(e)}
                  />
                }
                label={t(
                  "deviceRegistration.AllowmanagerstomodifyAccessPoints"
                )}
              />
            </FormControl>

            <ButtonContainer
              style={{
                display: saveButtonStatus ? "none" : "flex",
                marginTop: "20px",
                marginBottom: "10px",
              }}
            >
              <Button
                onClick={() => onClickResetBtn()}
                type="secondary"
                style={{
                  ...ButtonStyle,
                  backgroundColor: "#757575",
                  margin: "8px",
                }}
              >
                {t("deviceRegistration.button.resetDefault")}
              </Button>
              <Button
                onClick={() => onClickCancelBtn()}
                type="primary"
                style={{
                  marginLeft: "20px",
                  background: "white",
                  color: "black",
                  border: "2px solid gray",
                }}
              >
                {t("cancel")}
              </Button>
              <Button
                style={
                  isLoading ? { opacity: "0.7", ...ButtonStyle } : ButtonStyle
                }
                onClick={handleSave}
                type="primary"
                disabled={isLoading}
              >
                {t("saveChanges")}
              </Button>
            </ButtonContainer>
          </div>
          <Typography style={{ marginTop: "20px", marginBottom: "10px" }}>
            <Link
              href="/dashboard/deviceslist/mobile-devices"
              underline="always"
            >
              {t("deviceRegistration.mobileDevicesPageUrl")}
            </Link>
          </Typography>

          <Typography style={{ marginBottom: "10px" }}>
            <Link href="/dashboard/aps" underline="always">
              {t("deviceRegistration.accessPointsPageUrl")}
            </Link>
          </Typography>

          <Typography style={{ marginBottom: "10px" }}>
            <Link href="/dashboard/sites" underline="always">
              {t("deviceRegistration.sitesPageUrl")}
            </Link>
          </Typography>
        </div>

        <BottomNavLinks />
      </StyledContentWrapper>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
      >
        <SnackbarContent error={serverResponse.current.status ? false : true}>
          {serverResponse.current.msg}
        </SnackbarContent>
      </Snackbar>
    </>
  );
}